import Loading from '@platform-ui-common/components/Loading/index.js';
import { Theme } from '@radix-ui/themes';
import { Suspense } from 'react';
import { BrowserRouter, Redirect, Route, Switch, useParams } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import ApplicantRoutes from './application/ApplicantRoutes.js';
import PostHogPageView from './application/components/Pageview/PosthogPageview.js';
import ErrorBoundary from './application/pages/ErrorBoundary/index.js';
import { IdentityRoutes } from './auth/Routes.js';
import useLogoutChannel from './auth/hooks/useLogoutChannel.js';
import EligibilityRoutes from './eligibility/Routes.js';
import { PHProvider } from './providers/posthog.js';
import Routes, { AuthenticatedRoute, UnauthenticatedRedirect } from './utilities/Routes.js';

export default function AppRoutes(): JSX.Element {
  const { partnerId } = useParams<{ partnerId: string }>();
  useLogoutChannel();

  return (
    <Theme accentColor="indigo">
      <Suspense fallback={<Loading size="XXL" fullPage />}>
        <BrowserRouter basename={`/${partnerId}`}>
          <CompatRouter>
            <PHProvider>
              <ErrorBoundary>
                <Switch>
                  <Route path={[Routes.IDENTITY]} component={IdentityRoutes} />
                  <Route path={Routes.ELIGIBILITY} component={EligibilityRoutes} />
                  <Redirect from={Routes.LEGACY_INTRO} to={Routes.ELIGIBILITY} />
                  <AuthenticatedRoute
                    path={[Routes.PROGRAM, Routes.APPLICATION, Routes.CLAIM, Routes.CASE]}
                    component={ApplicantRoutes}
                    tenantRole="applicant"
                  />
                  <UnauthenticatedRedirect />
                </Switch>
              </ErrorBoundary>
              <PostHogPageView />
            </PHProvider>
          </CompatRouter>
        </BrowserRouter>
      </Suspense>
    </Theme>
  );
}
